import {useState} from 'react';

import {ShortcutLayer} from '../../../../../hooks/use-shortcuts';
import {useEnvironment} from '../../../../../hooks/use-session';
import {useTranslation} from '../../../../../hooks/use-translation';
import {switchEnvironment} from '../../../../../helpers/auth-helper';
import {EnvironmentAlertModal} from '../../../../pages/admin/terminal/partials/environment-alert-modal';

// the version of the app: a commit hash shortened as on GitHub, or the build time of a build without one
const shortBuildId = /^[0-9a-f]{40}$/.test(__BUILD_ID__) ? __BUILD_ID__.slice(0, 7) : __BUILD_ID__;

/** The left of the top bar: the logo, the name, the build and the environment, which switches to the other one. */
export const TopNavLogo = (): React.JSX.Element => {
    const t = useTranslation();
    const environment = useEnvironment();
    const [showAlert, setShowAlert] = useState(false);
    const isDevelopment = 'development' === environment;

    const toggleEnvironment = (event: React.MouseEvent<HTMLButtonElement>): void => {
        // like the terminal buttons: Enter or Space (a scan) must not toggle it again after the alert closed
        event.currentTarget.blur();

        if (isDevelopment) {
            switchEnvironment('production');
            return;
        }

        setShowAlert(true);
    };

    return (
        <>
            <img src="/images/logo.svg" className="top-bar-logo" alt="Polyestershoppen" />
            <span className="top-bar-title">
                Shipping Terminal <small title={__BUILD_ID__}>{shortBuildId}</small>
            </span>
            <button
                type="button"
                tabIndex={-1}
                className="button button-small top-bar-environment"
                data-environment={environment}
                aria-label={t('topNav.environment', {
                    environment,
                    other: isDevelopment ? 'production' : 'development',
                })}
                onClick={toggleEnvironment}
            >
                {environment}
            </button>
            {showAlert && (
                <ShortcutLayer>
                    <EnvironmentAlertModal onRequestClose={() => setShowAlert(false)} />
                </ShortcutLayer>
            )}
        </>
    );
};
